<template>
  <div class="modal fade modal-email-driver" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          Email Load Details
        </div>
        <div class="modal-body m-t-sm">

          <div class="form-group-outer">
            <div class="form-group float-label-control" :class="{ 'has-error': errors.has('to') }">
              <label for="">To</label>
              <input type="email" v-model="email.to" name="to" class="form-control" placeholder="To" v-float-label v-validate="'required|email'" />
            </div>
          </div>

          <div class="form-group-outer">
            <div class="form-group float-label-control">
              <label for="">CC</label>
              <input type="text" v-model="email.cc" class="form-control" placeholder="CC" v-float-label />
            </div>
          </div>

          <div class="form-group-outer">
            <div class="form-group float-label-control" :class="{ 'has-error': errors.has('subject') }">
              <label for="">Subject</label>
              <input type="text" v-validate="'required'" name="subject" v-model="email.subject" class="form-control" placeholder="Subject" value="" v-float-label />
            </div>
          </div>

          <quill v-model="email.message" placeholder="Write a message..." :height="300" name="message" v-validate="'required'"></quill>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-default" data-dismiss="modal">Cancel</button>
          <ladda-button :on-click="handleSendEmail" type="success" size="small"><i class="fa fa-send"></i> Send</ladda-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import { Quill, LaddaButton } from 'components/forms'
  import { notify } from 'utils'
  import $ from 'jquery'

  export default {
    components: {
      Quill,
      LaddaButton
    },

    data () {
      return {
        email: {
          to: null,
          cc: null,
          subject: null,
          message: null
        }
      }
    },

    mounted () {
      $(this.$el).on('show.bs.modal', this.resetRecipientsAndSubject)
    },

    beforeDestroy () {
      $(this.$el).off('show.bs.modal', this.resetRecipientsAndSubject)
    },

    computed: {
      ...mapGetters('load', ['loadDecorated'])
    },

    methods: {
      ...mapActions('load', ['emailDriver']),

      /**
       * Reset the emails recipients and subject when the modal loads.
       *
       * @return void
       */
      resetRecipientsAndSubject () {
        this.email = {
          to: this.loadDecorated.driver && this.loadDecorated.driver.email,
          cc: null,
          subject: `Load ${this.loadDecorated.reference_number} ${this.loadDecorated.commodity_and_location}`,
          message: null
        }

        this.$nextTick(this.clearValidationErrors)
      },

      /**
       * Validate and send email.
       *
       * @return Promise
       */
      handleSendEmail () {
        const notifyFailed = () => {
          if (this.errors) {
            const errors = this.errors.errors
            for (const error in errors) {
              notify.error(errors[error].msg)
            }
          }
        }

        const notifySuccess = () => {
          this.resetRecipientsAndSubject()

          $(this.$el).modal('hide')
        }

        let payload = {
          id: this.loadDecorated.id,
          payload: this.email
        }

        return this.validateAll().then(() => {
          return this.emailDriver(payload)
        }).then(notifySuccess).catch(notifyFailed)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// EmailModal.vue?2ae9ebaa